const isValidNumber = (value: string): boolean => /^-?\d+(\.\d+)?$/.test(value);

export const compareNumericStrings = (
  first: string,
  second: string,
  isGreater = false
): boolean => {
  if (!isValidNumber(first) || !isValidNumber(second)) {
    return false;
  }

  const firstNumber = parseFloat(first);
  const secondNumber = parseFloat(second);

  if (isGreater) {
    return firstNumber > secondNumber;
  }

  return firstNumber < secondNumber;
};
